<template>
  <transition name="note-editor-editor-loading">
    <div class="pa-note-editor-loading" v-if="isLoading">
      <div class="pa-wrapper pa-wrapper-content">
        <div class="pa-field pa-field-content">
          <PuffLoadingImage class="waiting-loader" stroke="#BB9A66" />
        </div>
      </div>

      <div class="pa-wrapper pa-wrapper-overlay">
        <div class="pa-field pa-field-overlay"></div>
      </div>
    </div>
  </transition>
</template>

<script>
import PuffLoadingImage from '@/components/Parts/PAParkNoteEditorQuillNew/PAParkNoteEditorLoading/Images/puff.svg?inlineN'

export default {
  components : {
    PuffLoadingImage
  },

  computed : {
    isLoading(){
      return this.$store.state.parkNote.isEditorLoading;
    }
  },
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
.note-editor-editor-loading{
  &-enter-active, &-leave-active{
    transition: opacity .4s;
  }

  &-enter, &-leave-to{
    opacity:0;
  }
}

.pa-note-editor-loading{
  .pa-wrapper{
    position: absolute;
    top:0;
    left:0;

    width:100%;
    height:100%;
    z-index: 1000;

    &-content{
      z-index: 1001;
      text-align: center;

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }

  .pa-field{
    width:100%;
    height:100%;

    &-content{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    &-overlay{
      background-color:black;
      opacity:.4;
    }
  }
}
</style>